import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "cancel-flow-relevant-books" }
const _hoisted_2 = {
  key: 1,
  class: "cancel-flow-relevant-books__list"
}
const _hoisted_3 = { class: "cancel-flow-relevant-books__info" }
const _hoisted_4 = { class: "cancel-flow-relevant-books__book-title" }
const _hoisted_5 = { class: "cancel-flow-relevant-books__book-author" }
const _hoisted_6 = { class: "cancel-flow-popup__footer" }

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import AppButton from '@/app/components/button/AppButton.vue'
import BookCardThumbnail from '@/app/components/book/card/BookCardThumbnail.vue'
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import { BillingView } from '@/models/billing'
import type { ReasonValue } from '@/models/billing.cancelFlow'
import { DocSortOption } from '@/models/doc'
import { BooksView } from '@/models/doc.book'
import type { BookListItem } from '@/models/interfaces'
import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'CancelFlowRelevantBooks',
  props: {
    billing: {},
    canceling: { type: Boolean },
    reason: {}
  },
  emits: ["continueCancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const router = useRouter()
const books = ref<BookListItem[]>([])
const loading = ref(true)

onMounted(async () => {
  Mixpanel.trackCancelFlowStepShown(props.billing, 'books', props.reason)
  try {
    const [booksData, ownedIds, docsUserData] = await Promise.all([
      backend.getBooksWithRecommendations(),
      backend.getOwnedBookIds(),
      backend.getDocsUserData(),
    ])
    const booksNotSeenBefore = booksData.data.filter((b) => !ownedIds.has(b.id))
    const view = await BooksView.createView(
      { data: booksNotSeenBefore },
      docsUserData,
      DocSortOption.recommended,
      false,
      false,
    )
    books.value = view.docs.slice(0, 5)
  } catch (err) {
    Sentry.captureException(err)
  } finally {
    loading.value = false
  }
})

function trackButtonClick(button: string): void {
  Mixpanel.trackCancelFlowButtonClick(
    props.billing,
    'books',
    button,
    props.reason,
  )
}

function onOpenBook(): void {
  trackButtonClick('open_book')
}

function onRequestSummary(): void {
  trackButtonClick('request_summary')
  router.push({ name: 'help' })
}

function onEndMembership(): void {
  trackButtonClick('end_membership')
  emit('continueCancel')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "cancel-flow-relevant-books__header" }, [
        _createElementVNode("h2", { class: "cancel-flow-relevant-books__title" }, " These summaries may be relevant to you "),
        _createElementVNode("p", { class: "cancel-flow-relevant-books__subtitle" }, " Based on your interests ")
      ], -1)),
      (loading.value)
        ? (_openBlock(), _createBlock(LoadingSpinner, {
            key: 0,
            class: "cancel-flow-relevant-books__loading"
          }))
        : (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(books.value, (book) => {
              return (_openBlock(), _createElementBlock("li", {
                key: book.id
              }, [
                _createVNode(_component_router_link, {
                  class: "cancel-flow-relevant-books__item",
                  to: {
            name: 'book.page',
            params: { url_slug: book.url_slug, position: 1 },
          },
                  onClick: onOpenBook
                }, {
                  default: _withCtx(() => [
                    _createVNode(BookCardThumbnail, {
                      class: "cancel-flow-relevant-books__cover",
                      doc: book
                    }, null, 8, ["doc"]),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("h3", _hoisted_4, _toDisplayString(book.title), 1),
                      _createElementVNode("p", _hoisted_5, " By " + _toDisplayString(book.author), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ]))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(AppButton, {
        outlined: true,
        class: "cancel-flow-popup__cta",
        onClick: onRequestSummary
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Request a summary ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(AppButton, {
        danger: true,
        loading: __props.canceling,
        disabled: __props.canceling,
        class: "cancel-flow-popup__cta",
        onClick: onEndMembership
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" End my membership ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ], 64))
}
}

})